import { useState, useEffect, memo } from "react";
import { useNavigate } from 'react-router-dom';
import { MdWifi, MdWifiOff, MdCheckCircleOutline, MdOutlineCancel, MdHourglassEmpty } from "react-icons/md";
import { differenceInMinutes } from 'date-fns';
import Tooltip from '@mui/material/Tooltip';

const statusConfig = {
    true: { icon: <MdCheckCircleOutline color="#22c55e" className="w-full h-full object-contain p-1" />, },
    false: { icon: <MdOutlineCancel color="#ef4444" className="w-full h-full object-contain p-1" />, },
    pending: { icon: <MdHourglassEmpty color="#f97316" className="animate-spin w-full h-full object-contain p-1" />, },
};

const StatusButtonChangeMade = memo(({ update }) => {
    const [, forceRender] = useState(0);
    useEffect(() => {
        const timeout = setTimeout(() => { forceRender(v => v + 1); }, 330000);
        return () => clearTimeout(timeout);
    }, []);
    const diff = differenceInMinutes(new Date(), new Date(update.ts));
    const config = statusConfig[
        update.LastChangeMade
            ? "true"
            : (diff >= process.env.REACT_APP_TIME_LIMIT)
                ? "false"
                : "pending"
    ];
    return (config.icon);
});

export default function ButtonInternet({ item, Wifi, ChangeMade, Activate }) {
    const navigate = useNavigate();
    return (
        <>
            {Wifi && (

                <Tooltip title="Estado de conexión" arrow
                    PopperProps={{ modifiers: [{ name: 'offset', options: { offset: [0, -4], }, },], }}
                    componentsProps={{
                        tooltip: { sx: { backgroundColor: '#fff', color: '#2e354d', fontSize: '12px', fontWeight: '600', boxShadow: '2px 2px 2px 0', }, },
                        arrow: { sx: { color: '#2e354d', }, },
                    }} placement="top">
                    <button
                        className = "absolute w-[10%] h-[10%] bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-[#3d435bc6] to-[#3d4668] top-0 right-0 rounded-[0px_16px_0px_16px] shadow-lg shadow-black/40 hover:brightness-110 active:scale-95 cursor-pointer z-20 transition"
                        onClick={(e) => {
                            Activate && e.stopPropagation();
                            Activate && navigate(`/Dashboard/Conexion/${item.dataInfo.Path}`);
                        }}
                    >
                        {item.statePanel.InternetConect.State
                            ? <MdWifi className="w-full h-full object-contain p-1" color="#22c55e" />
                            : <MdWifiOff className="w-full h-full object-contain p-1" color="#ef4444" />}
                    </button>
                </Tooltip>
            )}

            {ChangeMade && (
                <Tooltip title="Ultima modificación" arrow
                    PopperProps={{ modifiers: [{ name: 'offset', options: { offset: [0, -4], }, },], }}
                    componentsProps={{
                        tooltip: { sx: { backgroundColor: '#fff', color: '#2e354d', fontSize: '12px', fontWeight: '600', boxShadow: '2px 2px 2px 0', }, },
                        arrow: { sx: { color: '#2e354d', }, },
                    }} placement="top">
                    <button
                        className="absolute w-[10%] h-[10%] bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-[#3d435bc6] to-[#3d4668] top-0 left-0 rounded-[16px_0px_16px_0px] shadow-lg shadow-black/40 hover:brightness-110 active:scale-95 cursor-pointer z-20 transition"
                        onClick={(e) => {
                            Activate && e.stopPropagation();
                            Activate && navigate(`/Dashboard/Conexion/${item.dataInfo.Path}`);
                        }}
                    >
                        <StatusButtonChangeMade update={item.statePanel.LastChange} />
                    </button>
                </Tooltip>
            )}
        </>
    )
}
